/**
 * Normalizza gli URL restituiti dal backend prima di passarli a WorkApi.
 *
 * WorkApi ha gia `/api/` come baseURL. Gli endpoint documentali possono
 * essere esposti anche come URL pubblici `/api/...`; senza normalizzazione
 * Axios li combinerebbe in `/api/api/...`.
 */
export function normalizeWorkApiRequestUrl(url) {
    if (typeof url !== "string") return url;

    const normalized = url.trim();
    return normalized.replace(/^\/api\//, "/");
}
